import memoize from 'lodash/memoize';

import { DesignData } from 'editor/src/store/design/types';
import { DEFAULT_LOW_DPI, DEFAULT_MEDIUM_DPI } from 'editor/src/store/hostSettings/slice';
import { DpiLevels } from 'editor/src/store/hostSettings/types';

const getDpiLevelsFromDesign = (designData: DesignData | undefined): DpiLevels => {
  const restrictions = designData?.resolution?.dpi;
  return {
    low: restrictions?.min || DEFAULT_LOW_DPI,
    medium: restrictions?.ok || DEFAULT_MEDIUM_DPI,
  };
};

const getDpiLevelsFromDesignMemoized = memoize(
  (designData: DesignData | undefined) => getDpiLevelsFromDesign(designData),
  (designData: DesignData | undefined) => designData?.resolution?.dpi,
);

export default getDpiLevelsFromDesignMemoized;
